import { Component, ElementRef, HostListener, signal, viewChild } from '@angular/core';
import { KopConfigService } from '../../core/kop-config.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { KanaalService } from '../../kanaal/kanaal.service';
import { KopModulesService } from '../../modules/kop-modules.service';
import { PropsServiceService } from '../props-service.service';
import { KlassiekLosDefComponent } from '../klassiek/klassiek-los-def/klassiek-los-def.component';
import { KlassiekServoComponent } from '../klassiek/klassiek-servo/klassiek-servo.component';
import { AlarmTextsComponent } from '../alarm-texts/alarm-texts.component';
import { KlassiekAlarmsComponent } from '../klassiek/klassiek-alarms/klassiek-alarms.component';
import { KlassiekBijzPrgmsComponent } from '../klassiek/klassiek-bijz-prgms/klassiek-bijz-prgms.component';
import { UurenTekstenComponent } from '../uuren-teksten/uuren-teksten.component';
import { KlassiekUrenComponent } from '../klassiek/klassiek-uren/klassiek-uren.component';

@Component({
  selector: 'klassiek-props',
  templateUrl: './klassiek-props.component.html',
  styleUrl: './klassiek-props.component.scss',
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'PropsComponent'
    }
  ]

})
export class KlassiekPropsComponent {

  constructor(public kopConfigService: KopConfigService, public jsBridgeService: JSBridgeService,
    public kopModulesService: KopModulesService, public kanaalService: KanaalService, public propsService: PropsServiceService) {

  }

  public losDefComponent = viewChild<KlassiekLosDefComponent>("losDefs");
  public koelingComponent = viewChild<KlassiekLosDefComponent>("koeling");
  public verwarmingComponent = viewChild<KlassiekLosDefComponent>("verwarming");
  public droogwandComponent = viewChild<KlassiekLosDefComponent>("droogwand");

  public servoComponent = viewChild(KlassiekServoComponent);

  public alarmTextsComponent = viewChild(AlarmTextsComponent);
  public alarmsComponent = viewChild(KlassiekAlarmsComponent);  
  public bijzPrgmsComponent = viewChild(KlassiekBijzPrgmsComponent);

  public uurenTextComponent = viewChild(UurenTekstenComponent);
  public uurenComponent = viewChild(KlassiekUrenComponent);

  @HostListener('window:keydown.alt.d', ['$event'])
  shortcutLosDef(event: Event) {
    let ld = this.losDefComponent();
    if (ld != undefined) {
      ld.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.k', ['$event'])
  shortcutKoleing(event: Event) {
    let ld = this.koelingComponent();
    if (ld != undefined) {
      ld.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.v', ['$event'])
  shortcutVerwarming(event: Event) {
    let ld = this.verwarmingComponent();
    if (ld != undefined) {
      ld.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.w', ['$event'])
  shortcutDroogwand(event: Event) {
    let ld = this.droogwandComponent();
    if (ld != undefined) {
      ld.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.s', ['$event'])
  shortcutServo(event: Event) {
    let sc = this.servoComponent();
    if (sc != undefined) {
      sc.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.t', ['$event'])
  shortcutAlarmTexts(event: Event) {
    let at = this.alarmTextsComponent();
    if (at != undefined) {
      at.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.l', ['$event'])
  shortcutAlarms(event: Event) {
    let al = this.alarmsComponent();
    if (al != undefined) {
      al.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.p', ['$event'])
  shortcutBijzPrgms(event: Event) {
    let bp = this.bijzPrgmsComponent();
    if (bp != undefined) {
      bp.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.e', ['$event'])
  shortcutUurenTeksten(event: Event) {
    let ut = this.uurenTextComponent();
    if (ut != undefined) {
      ut.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:keydown.alt.u', ['$event'])
  shortcutUuren(event: Event) {
    let u = this.uurenComponent();
    if (u != undefined) {
      u.open();
    }
    event.preventDefault();
    event.stopPropagation();
  }
}
